import { render, staticRenderFns } from "./products.page.vue?vue&type=template&id=f629d2f4&scoped=true&"
import script from "./products.page.vue?vue&type=script&lang=js&"
export * from "./products.page.vue?vue&type=script&lang=js&"
import style0 from "./products.page.vue?vue&type=style&index=0&id=f629d2f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f629d2f4",
  null
  
)

export default component.exports